import { AlertStyled, IconWrapper } from 'components/alert/alert.styles';
import { lighten, rem, size } from 'polished';
import styled from 'styled-components';

export const ReminderCardStyled = styled(AlertStyled)`
  display: flex;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.palette.white};

  &:hover {
    background-color: ${({ theme }) =>
      lighten(0.45, theme.colors.palette.grey)};
  }

  * {
    color: ${({ theme }) => theme.colors.palette.black};
  }

  time {
    display: block;
    margin-bottom: ${rem(4)};
  }

  ${IconWrapper} {
    margin: 0;
    margin-right: ${rem(12)};
    padding: 0;

    svg {
      ${size(rem(16))};
    }
  }
`;
